import React, { useState, useEffect } from "react";
import Combobox from "react-widgets/Combobox";
import "react-widgets/styles.css";
export default function ServiceForm({
  isOpen,
  service,
  serviceGroupNameList,
  serviceGroup,
  maxRow,
  title,
  onSave,
  onClose,
  errors,
}) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState(0);
  const [displayOrderNumber, setDisplayOrderNumber] = useState(1);
  const [isRepeatable, setIsRepeatable] = useState(false);
  const [selectedServiceGroup, setSelectedServiceGroup] = useState(false);

  // Fill fields when service is provided
  useEffect(() => {
    if (service) {
      setName(service.name || "");
      setDescription(service.description || "");
      setPrice(service.price || 0);
      setIsRepeatable(service.isRepeatable || false);
      setSelectedServiceGroup(serviceGroup || "");
      setDisplayOrderNumber(service.displayOrderNumber);
    } else {
      clearForm();
    }
  }, [service, isOpen]);

  // Clears form fields
  const clearForm = () => {
    setName("");
    setDescription("");
    setPrice(0);
    setIsRepeatable(false);
    setSelectedServiceGroup("");
    setDisplayOrderNumber(1);
  };

  // Handle save
  const handleSave = () => {
    const updatedService = {
      ...service,
      name,
      description,
      price,
      isRepeatable,
      selectedServiceGroup,
      displayOrderNumber,
    };
    onSave(updatedService); // send back to parent
  };

  return (
    <div className={`modal  ${isOpen ? "show" : ""}`} tabindex="-1">
      <div className="modal-dialog  modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">{title}</h5>
          </div>
          <div className="modal-body">
            <div className="row client-form">
              <div className="col-12 form-control-container">
                <div className="flex-grow-1">
                  <label
                    htmlFor="tva"
                    className="form-label form-control-label"
                  >
                    Service Group
                  </label>
                  <Combobox
                    onChange={(value) => setSelectedServiceGroup(value)}
                    data={serviceGroupNameList}
                    dataKey="id"
                    textField="name"
                    value={selectedServiceGroup}
                    defaultValue={selectedServiceGroup}
                    containerClassName={" form-combobox"}
                  />
                  {errors.serviceGroup && (
                    <div style={{ color: "red", fontSize: "12px" }}>
                      {errors.serviceGroup}
                    </div>
                  )}
                </div>
              </div>
              <div className="col-12 form-control-container">
                <label htmlFor="name" className="form-label form-control-label">
                  Name
                </label>
                <input
                  type="text"
                  className="form-control form-input"
                  value={name}
                  onChange={(e) => setName(e.target.value)}
                />
                {errors.name && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {errors.name}
                  </div>
                )}
              </div>
              <div className="col-12 form-control-container">
                <label htmlFor="name" className="form-label form-control-label">
                  Price
                </label>
                <input
                  type="number"
                  className="form-control form-input"
                  value={price}
                  onChange={(e) => setPrice(Number(e.target.value))}
                />
                {errors.price && (
                  <div style={{ color: "red", fontSize: "12px" }}>
                    {errors.price}
                  </div>
                )}
              </div>
            </div>
            <div className="col-12 form-control-container">
              <label
                htmlFor="orderNumber"
                className="form-label form-control-label"
              >
                Display Order Number
              </label>
              <input
                type="number"
                className="form-control form-input"
                min="1"
                value={displayOrderNumber}
                max={maxRow}
                onChange={(e) => setDisplayOrderNumber(Number(e.target.value))}
              />
              {errors.displayOrderNumber && (
                <div style={{ color: "red", fontSize: "12px" }}>
                  {errors.displayOrderNumber}
                </div>
              )}
            </div>
            <div className="col-12 form-control-container">
              <label htmlFor="name" className="form-label form-control-label">
                Repeatable Service
              </label>
              <input
                type="checkbox"
                className="mr-2"
                checked={isRepeatable}
                onChange={(e) => setIsRepeatable(e.target.checked)}
              />
            </div>
          </div>
          <div className="col-12 form-control-container">
            <label htmlFor="name" className="form-label form-control-label">
              Description
            </label>
            <textarea
              className="form-control form-input"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
            />
          </div>
          <div className="d-flex justify-content-end modal-footer mt-4 mb-3">
            <button
              type="submit"
              className="btn btn-secondary me-2"
              onClick={() => onClose()}
            >
              Cancel
            </button>{" "}
            <button
              type="submit"
              className="btn btn-primary"
              onClick={(e) => handleSave(e)}
            >
              Save
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
